import RequestAbstract from "./RequestAbstract";
import helper from "actions/helper";

export default class DoctorsScheduleShortList extends RequestAbstract {
    get link() {
        return this.links.doctorSchedulesShortList;
    }

    async getAllByClinic(clinicId) {
        const yearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
        return this.getAllFiltered([
            [
                { field: "domainId", op: "=", value: clinicId },
                { field: "doctorId", op: ">", value: 0 },
                { field: "beginDate", op: ">", value: helper.date.toStr(yearAgo) },
            ]
        ], [{
            "field": "beginDate",
            "direction": "ASC"
        }]);
    }

    async getByCabinetVeDoctor(domainId, doctorId, cabinetId, dt1, dt2) {

        return this.getAllFiltered([
            [
                { field: "domainId", op: "=", value: domainId },
                { field: "doctorId", op: "=", value: doctorId },
                { field: "cabinetId", op: "=", value: cabinetId },
                { field: "beginDate", op: ">", value: helper.date.toStr(dt1) },
                { field: "endDate", op: "<", value: helper.date.toStr(dt2) },
            ]
        ], [{
            "field": "beginDate",
            "direction": "ASC"
        }]);
    }
}
